import React from 'react';
import { Label, Grid } from 'semantic-ui-react';
import withReduxFormValidation from '../../../HOCs/withReduxFormValidation';
import Input from 'semantic-ui-react/dist/commonjs/elements/Input/Input';

const AccountName = (props) => {
  return <Input {...props} placeholder="name" />;
};

export default withReduxFormValidation(AccountName);
